import { render } from "./AccountDeleteComplete.vue?vue&type=template&id=0422db38"
import script from "./AccountDeleteComplete.vue?vue&type=script&lang=js"
export * from "./AccountDeleteComplete.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/v2/AccountDeleteComplete.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0422db38"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0422db38', __exports__)) {
    api.reload('0422db38', __exports__)
  }
  
  module.hot.accept("./AccountDeleteComplete.vue?vue&type=template&id=0422db38", () => {
    api.rerender('0422db38', render)
  })

}


export default __exports__